import React from 'react';

/**
 * Returns a ref for specified input element and focuses it on first render.
 * @param select Whether to also select text in input element.
 */
export const useFocusElement = <T extends HTMLInputElement>(
  selection?: boolean | { start: number; end: number },
) => {
  const ref = React.useRef<T>(null);

  React.useEffect(() => {
    if (ref?.current) {
      ref.current?.focus();
      if (selection) {
        ref.current.select();
        if (typeof selection !== 'boolean') {
          ref.current.setSelectionRange(selection.start, selection.end);
        }
      }
    }
  }, [selection]);

  return ref;
};
